<template>
  <div class="full-height flex quote-container">
    <div :class="[quoteData.modal === 'RODOVIARIA' ? 'bg-quotation-terrestre' : 'bg-quotation']" class="text-center pv-4 ph-5">
      <img
        alt="Prime Internacional"
        v-if="quoteData.typeOfProcess !== 'ENCOMENDA'"
        class="mb-2 mt-1"
        src="https://s3.sa-east-1.amazonaws.com/public.prime.com.vc/logo/nova/logo-horizontal-branca.svg"
        width="250"
      />
      <img
        alt="Sowport Importação"
        v-else
        class="mb-2 mt-1"
        src="https://s3.sa-east-1.amazonaws.com/public.sowport.com.br/logo/logo-cinza-horizontal.png"
        width="170"
      />

      <h1 class="text-white mb-3 mt-3">
        <b class="block">PORTAL DOS PARCEIROS</b>
        <div class="mt-1">COTAÇÃO DE FRETE</div>
      </h1>

      <p class="text-white mb-2">
        <b>Olá {{ quoteData.pessoa }},</b>
        você está aqui porque clicou no link do email de Pedido de Cotação do nosso Processo de
        Importação <b>{{ quoteData.referenciaNova }}</b
        >, enviado no dia <b>{{ quoteData.envio | moment('DD/MM/YYYY') }}</b> e foi redicionado a
        esta página, para preencher e nos enviar a esta cotação.
      </p>
    </div>

    <div v-if="quoteExpired == false" class="quotation-form full-height overflow pv-4 ph-4">
      <h1 class="text-center text-xg text-bold mb-1">Cotação de Frete Internacional</h1>
      <p class="text-center mb-3">
        Preencha todos os campos com asterisco (*) e faça upload do PDF da Cotação de Frete
      </p>

      <form class="columns gap2 ai-gs" @submit.prevent="saveShippingQuote">
        <div class="span-4">
          <Input
            v-model="quoteData.agente"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'agente')"
            className="input-quotation"
            label="Forwarder"
            name="forwarder"
            type="text"
          />
        </div>

        <div class="span-4">
          <Input
            v-model="customerExpectedReceiptDate"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'customerExpectedReceiptDate')"
            className="input-quotation"
            label="Expectativa de Recebimento do Cliente"
            name="customerExpectedReceiptDate"
            type="text"
          />
        </div>

        <div class="span-4">
          <Input
            v-model="datesGoodsReadinesDate"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'datesGoodsReadinesDate')"
            className="input-quotation"
            label="Prontidão"
            name="datesGoodsReadinesDate"
            type="text"
          />
        </div>

        <div class="span-4" v-if="quoteData.localEmbarqueEnitidade">
          <Input
            v-model="quoteData.localEmbarqueEnitidade.name"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'localEmbarqueEnitidade')"
            className="input-quotation"
            label="Local do Embarque"
            name="embarque"
            type="text"
          />
        </div>

        <div class="span-4" v-else>
          <Input
            v-model="quoteData.localEmbarque"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'localEmbarque')"
            className="input-quotation"
            label="Local do Embarque"
            name="embarque"
            type="text"
          />
        </div>

        <div class="span-4 columns gap2">
          <div class="span-6">
            <Input
              v-model="quoteData.incoterm"
              :disabled="true"
              :error="validationErrors.find((err) => err.path === 'incoterm')"
              :required="true"
              className="input-quotation"
              label="Incoterm"
              name="incoterm"
              type="text"
            />
          </div>

          <div class="span-6">
            <Input
              v-model="quoteData.modal"
              :disabled="true"
              :error="validationErrors.find((err) => err.path === 'modal')"
              className="input-quotation"
              label="Modal"
              name="modal"
              type="text"
            />
          </div>
        </div>

        <div class="span-2">
          <Input
            v-model="urgentText"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'urgent')"
            className="input-quotation"
            label="Urgente"
            name="urgent"
            type="text"
          />
        </div>

        <div class="span-2">
          <Input
            v-model="imoText"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'imo')"
            className="input-quotation"
            label="IMO"
            name="imo"
            type="text"
          />
        </div>

        <div class="span-8">
          <Input
            v-model="quoteData.typeOfMerchandise"
            :disabled="true"
            :error="validationErrors.find((err) => err.path === 'typeOfMerchandise')"
            className="input-quotation"
            label="Tipo de Mercadoria"
            name="typeOfMerchandise"
            type="text"
          />
        </div>

        <div class="span-12">
          <label class="flex ai-c jc-sb" for="detalhesCotacao">Detalhes da Cotação</label>
          <textarea
            id="detalhesCotacao"
            v-model="quoteData.detalhes"
            class="input-quotation"
            disabled
            name="detalhesCotacao"
          ></textarea>
        </div>

        <div class="separator span-12" v-if="quoteData?.documentosDownload?.length > 0"></div>

        <div class="span-12" v-if="quoteData?.documentosDownload?.length > 0">
          <div class="flex ai-c jc-sb mb-1">
            <h4>Documentos para Download</h4>
          </div>
          <DocumentsCard :docs="quoteData.documentosDownload" :quoteData="quoteData"/>
        </div>

        <div class="separator span-12"></div>

        <div class="span-12 columns gap2">
          <div class="span-4">
            <label class="flex ai-c jc-sb">Porto/Aeroporto de Destino*</label>
            <Select class="select-form" classStyledSelect="port-select" classSelectList="select-new" v-model="quoteData.portoDestino" :options="ports" :title="null" :error="validationErrors.find((err) => err.path === 'portoDestino')"></Select>
          </div>
          <div class="span-4" v-if="quoteData.tipoEmbarque !== 'LCL' && quoteData.modal === 'MARITIMA'">
            <label class="flex ai-c jc-sb">Armador*</label>
            <Select class="select-form" classStyledSelect="arm-select" classSelectList="select-new" v-model="quoteData.armador" :options="armadores" :title="null" :error="validationErrors.find((err) => err.path === 'armador')"></Select>
          </div>
          <div class="span-4" v-if="quoteData.tipoEmbarque === 'LCL'">
            <label class="flex ai-c jc-sb">Local de Desova*</label>
            <Select class="select-form" classStyledSelect="desova-select" classSelectList="select-new" v-model="quoteData.localDesova" :options="ports" :title="null" :error="validationErrors.find((err) => err.path === 'localDesova')"></Select>
          </div>
        </div>

        <div class="span-12 columns gap2">
          <div class="span-4">
            <Input
              v-model="quoteData.freetime"
              :error="validationErrors.find((err) => err.path === 'freetime')"
              className="input-quotation text-bold text-black"
              label="Freetime (Dias)*"
              name="freetime"
              type="number"
            />
          </div>
          <div class="span-4">
            <Input
              v-model="quoteData.transittime"
              :error="validationErrors.find((err) => err.path === 'transittime')"
              className="input-quotation text-bold text-black"
              label="Transit Time (Dias)*"
              name="transittime"
              type="number"
            />
          </div>
          <div class="span-4 flex ai-fe">
            <label
              :class="['transbordo flex ai-c text-thin', quoteData.transbordo ? 'active' : '']"
              for="transbordo"
              style="margin-bottom: 0px"
            >
              <input
                id="transbordo"
                v-model="quoteData.transbordo"
                name="transbordo"
                type="checkbox"
              />
              {{ quoteData.transbordo ? 'COM TRANSBORDO' : 'SEM TRANSBORDO' }}
            </label>
          </div>
        </div>

        <div class="separator span-12" v-if="quoteData.tipoEmbarque !== 'LCL' && quoteData.modal === 'MARITIMA'"></div>

        <div class="span-12" v-if="quoteData.tipoEmbarque !== 'LCL' && quoteData.modal === 'MARITIMA'">
          <div class="flex ai-c jc-sb mb-1">
            <h4>Cadastrar Container</h4>
            <button type="button" @click.prevent="addContainer" class="btn solid primary text-uppercase small">Adicionar Container</button>
          </div>
          <table>
            <thead>
              <tr>
                <th>Quantidade Container</th>
                <th>Tipo do Container</th>
                <th class="text-right">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(container, index) in quoteData.containers" :key="index">
                <td>
                  <Input
                    v-model="container.quantity"
                    :error="validationErrors.find((err) => err.path === `containers[${index}].quantity`)"
                    :errorBackgroundColor="true"
                    className="input-quotation text-bold text-black"
                    label=""
                    :name="`quantity-${index}`"
                    type="number"
                  />
                </td>
                <td>
                  <Select
                    class="select-form"
                    :classStyledSelect="`type-container-${index}`"
                    classSelectList="select-new"
                    v-model="container.type"
                    :options="tipoContainer"
                    :title="null"
                    :error="validationErrors.find((err) => err.path === `containers[${index}].type`)"
                    :errorBackgroundColor="true"
                  ></Select>
                </td>
                <td class="text-right">
                  <button type="button" @click.prevent="deleteContainer(container, index)" class="btn solid danger text-uppercase small">Remover</button>
                </td>
              </tr>
              <tr v-if="!quoteData?.containers || quoteData.containers.length === 0">
                <td colspan="3" class="text-center">Nenhum container cadastrado</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="separator span-12"></div>

        <div class="span-12 columns gap2">
          <div class="span-12 flex mb-1 fd-c">
            <h4>Valores das Cotações</h4>
            <div v-if="validationErrors.find((err) => err.path === 'contacaoPreenhida')" class="field-error mt-1">
              {{ validationErrors.find((err) => err.path === 'contacaoPreenhida').message }}
            </div>
          </div>
          <div class="span-3 quotation">
            <label>Valor Total em Dolar $</label>
            <Money
              v-model="quoteData.valorTotalDolar"
              class="input-quotation text-bold text-black"
              v-bind="{
                decimal: ',',
                thousands: '.',
                masked: false,
              }"
            ></Money>
            <div v-if="validationErrors.find((err) => err.path === 'agente')" class="field-error">
              {{ validationErrors.find((err) => err.path === 'valorTotalDolar').message }}
            </div>
          </div>
        </div>
        <div class="span-12 columns gap2">
          <div class="span-3 quotation">
            <label class="flex fw-nw">Valor Total em Euro €</label>
            <Money
              v-model="quoteData.valorTotalEuro"
              class="input-quotation text-bold text-black"
              v-bind="{
                decimal: ',',
                thousands: '.',
                masked: false,
              }"
            ></Money>
            <div v-if="validationErrors.find((err) => err.path === 'agente')" class="field-error">
              {{ validationErrors.find((err) => err.path === 'valorTotalEuro').message }}
            </div>
          </div>
        </div>
        <div class="span-12 columns gap2">
          <div class="span-3 quotation">
            <label>Valor Total em Reais R$</label>
            <Money
              v-model="quoteData.valorTotalReais"
              class="input-quotation text-bold text-black"
              v-bind="{
                decimal: ',',
                thousands: '.',
                masked: false,
              }"
            ></Money>
            <div v-if="validationErrors.find((err) => err.path === 'agente')" class="field-error">
              {{ validationErrors.find((err) => err.path === 'valorTotalReais').message }}
            </div>
          </div>
        </div>

        <div class="span-12 columns gap2">
          <div class="span-3 quotation">
            <label class="flex fw-nw">Valor Total em Outra Moeda</label>
            <Money
              v-model="quoteData.valorTotalOutros"
              class="input-quotation text-bold text-black"
              v-bind="{
                decimal: ',',
                thousands: '.',
                masked: false,
              }"
            ></Money>
          </div>

          <div class="span-2 quotation-currency">
              <label class="flex ai-c jc-sb">Moeda</label>
              <Select class="select-form" classSelectList="select-new" @input="getCurrencyExchangeRate" v-model="quoteData.moeda" :options="currencies" :title="null" :error="validationErrors.find((err) => err.path === 'moeda')"></Select>
          </div>

          <div class="span-2 quotation-tax">
            <label class="flex fw-nw">Taxa da Moeda</label>
            <Money
              v-model="taxaMoeda"
              class="input-quotation text-bold text-black"
              disabled
              v-bind="{
                decimal: ',',
                thousands: '.',
                masked: false,
                precision: 5,
              }"
            ></Money>
          </div>
        </div>

        <div class="span-12">
          <label class="flex ai-c jc-sb" for="observacoesCotacao">Observações da Cotação</label>
          <textarea
            id="observacoesCotacao"
            v-model="quoteData.observacao"
            className="input-quotation text-bold text-black"
            name="observacoesCotacao"
          ></textarea>
        </div>

        <div class="span-12">
          <label
            :class="['upload-placeholder flex fd-c ai-c text-center', dragging && 'active', validationErrors.find((err) => err.path === 'documents') && 'error']"
            @dragover.prevent="dragover"
            @dragleave.prevent="dragleave"
            @drop.prevent="drop"
          >
            <CloudIcon class="text-primary mb-1" size="4rem" />
            <div class="pointer">
              <p class="text-uppercase text-primary">
                Clique aqui ou arraste aqui para dentro o PDF da Cotação do Frete
              </p>
            </div>
            <input id="files" class="hide" multiple name="files" type="file" @change="fileChange" />
          </label>
          <div v-if="validationErrors.find((err) => err.path === 'documents')" class="field-error mb-1">
            {{ validationErrors.find((err) => err.path === 'documents').message }}
          </div>

          <div v-if="documents.length > 0" class="table-overflow">
            <div
              v-for="(document, index) in documents"
              :key="index"
              class="flex ai-c fgap2 mb-1 pv-1"
            >
              <span class="text-bold">{{ document.name }}</span>
              <a class="text-danger" href="#" @click.prevent="documents.splice(index, 1)"> X </a>
            </div>
          </div>

          <div v-if="quoteData.documentos.length > 0" class="table-overflow">
            <div
              v-for="(documentSent, index) in quoteData.documentos"
              :key="`document-sent-${index}`"
              class="flex ai-c fgap2 mb-1 pv-1"
            >
              <span class="text-bold">{{ documentSent.description }}</span>
              <small>(Enviado em {{ documentSent.created | moment('DD/MM/YYYY') }} )</small>
            </div>
          </div>
        </div>

        <div class="span-12">
          <label class="flex ai-fs fgap1 text-thin text-md">
            <input
              id="aceite"
              v-model="quoteData.aceite"
              name="aceite"
              style="flex: 0 0 1.5rem; height: 1.5rem"
              type="checkbox"
            />
            <p style="margin-top: 5px">
              Declaro, que tenho permissão para enviar cotações aos clientes, que as informações
              acima são verdadeiras e que assumo inteira responsabilidade pelos dados informados.
            </p>
          </label>
        </div>

        <div class="span-12">
          <button
            :disabled="!quoteData.aceite"
            class="btn solid extra-big text-normal primary full-width"
          >
            ENVIAR COTAÇÃO
          </button>
        </div>
      </form>
    </div>

    <div v-else class="quotation-form full-height flex fd-c jc-c overflow pv-4 ph-4">
      <div class="flex fd-c ai-c jc-c">
        <NoDataIcon size="240px" />

        <h1 class="mt-4 mb-2 text-bold text-center">Cotação de Frete Internacional</h1>

        <p class="text-center">Esta cotação não esta mais disponível para alterações!</p>
      </div>
    </div>

    <Modal :handler="modalOpen" :useActions="true" @request-close="modalOpen = false">
      <template #content>
        <h3 class="text-center text-bold mb-2">Cotação de Frete Internacional</h3>
        <p class="text-center">{{ modalMessage }}</p>
      </template>

      <template #cancel-button>
        <button class="btn solid primary text-uppercase" @click.prevent="modalOpen = false">
          Clique aqui para continuar
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Money } from 'v-money';
import moment from 'moment';
// eslint-disable-next-line import/no-cycle
import * as yup from 'yup';
// eslint-disable-next-line import/no-cycle
import api from '@/services/api';
import Input from '@/components/DataInput/Input.vue';
import Modal from '@/components/Modal.vue';

import { CloudIcon, NoDataIcon } from '@/components/Icons';
import Select from '@/components/DataInput/Select.vue';
import Swal from 'sweetalert2';
import DocumentsCard from './DocumentsCard.vue';

export default {
  name: 'ShipQuotation',
  components: {
    NoDataIcon,
    CloudIcon,
    Input,
    Money,
    Modal,
    Select,
    DocumentsCard,
  },
  data() {
    return {
      quoteData: {
        moeda: {},
        aceite: false,
        documentos: [],
        containers: [],
      },
      taxaMoeda: 0,
      documents: [],
      dragging: false,
      modalOpen: false,
      modalMessage: false,
      modalWarnOpen: false,
      modalWarnMessage: false,
      validationErrors: [],
      quoteExpired: true,
      currencies: [],
      exchangeRates: [],
      ports: [],
      armadores: [],
      tipoContainer: [
        { label: 'DRY 20', value: 'DRY_20' },
        { label: 'DRY 40', value: 'DRY_40' },
        { label: 'HIGH CUBE 40', value: 'HIGH_CUBE_40' },
        { label: 'REEFER 20', value: 'REEFER_20' },
        { label: 'REEFER 40', value: 'REEFER_40' },
        { label: 'OPEN TOP 20', value: 'OPEN_TOP_20' },
        { label: 'OPEN TOP 40', value: 'OPEN_TOP_40' },
        { label: 'FLAT RACK 20', value: 'FLAT_RACK_20' },
        { label: 'FLAT RACK 40', value: 'FLAT_RACK_40' },
      ],
    };
  },
  async created() {
    this.toggleLoading(true);
    const codigoCotacao = this.$route.params.codigo;
    if (codigoCotacao) {
      try {
        await this.getCurrencies();
        await this.getPorts();
        await this.getArmadores();
        const response = await api.get(`/freightQuotation/retrieve/${codigoCotacao}`);

        if (response) {
          this.quoteData = response.data.data;
          if (this.quoteData.approved !== null) {
            throw new Error('Esta cotação não esta mais disponível para alterações!');
          } else if (this.quoteData.preenchimento !== null) {
            this.modalOpen = true;
            this.modalMessage = response.data.message;
            this.quoteExpired = false;
            this.getCurrencyExchangeRate(this.quoteData.moeda);
            this.quoteData.valorTotalDolar = this.quoteData.valorTotalDolar ?? 0;
            this.quoteData.valorTotalEuro = this.quoteData.valorTotalEuro ?? 0;
            this.quoteData.valorTotalOutros = this.quoteData.valorTotalOutros ?? 0;
            this.quoteData.valorTotalReais = this.quoteData.valorTotalReais ?? 0;
          } else {
            this.quoteData.valorTotalDolar = 0;
            this.quoteData.valorTotalEuro = 0;
            this.quoteData.valorTotalOutros = 0;
            this.quoteData.valorTotalReais = 0;
            this.quoteExpired = false;
          }
          this.quoteData.localEmbarque = this.quoteData.localEmbarqueEnitidade?.name ?? this.quoteData.localEmbarque;
        } else {
          throw new Error('Não foi possível recuperar a cotação!');
        }
      } catch (err) {
        console.log('errrrrrrrrrrrrrrrrr', err);
        this.quoteExpired = true;
      }
    }

    this.toggleLoading(false);
  },
  methods: {
    ...mapActions(['toggleLoading']),
    dragover() {
      this.dragging = true;
    },
    async getPorts() {
      const response = await api.get('/api/public/customs-eclosures/find-all-by-description?description=');
      this.ports = response.data.data.map((port) => ({
        label: port.description,
        value: port.id,
      }));
    },
    async getArmadores() {
      const response = await api.get('/api/public/shipowners/find-all-by-name?name=');
      this.armadores = response.data.data.map((armador) => ({
        label: armador.name,
        value: armador.id,
      }));
    },
    addContainer() {
      if (!this.quoteData.containers) {
        this.$set(this.quoteData, 'containers', []);
      }
      const newContainer = {
        quantity: 0,
        type: '',
      };
      this.quoteData.containers = [...this.quoteData.containers, newContainer];
    },
    drop(e) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        const file = e.dataTransfer.files[i];
        this.documents.push(file);
      }
      this.dragging = false;
    },
    fileChange(e) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        this.documents.push(file);
      }
    },
    dragleave() {
      this.dragging = false;
    },
    async getCurrencies() {
      try {
        const response = await api.get('/currencies');
        this.currencies = response.data.data?.currencies?.map((currency) => ({
          label: currency.name,
          value: currency.id,
          code: currency.code,
        })).filter((currency) => currency.code !== '220' && currency.code !== '978');
        this.exchangeRates = response.data.data.exchageRates;
      } catch (e) {
        console.error(e);
      }
    },
    async getCurrencyExchangeRate(value) {
      if (!value) {
        this.taxaMoeda = 0;
        return;
      }
      const currencySelected = this.currencies.find((currency) => currency.value === value);
      this.taxaMoeda = this.exchangeRates.filter((ex) => ex.code.toString() === currencySelected.code.toString())[0]?.currentBuyValue ?? 0;
    },
    async uploadFiles() {
      try {
        if (this.documents.length > 0) {
          const fileDataImg = new FormData();
          this.documents.map((doc) => fileDataImg.append('arquivo', doc));
          const response = await api.post(
            `/freightQuotation/saveShippingQuoteDocument/${this.quoteData.codigo}`,
            fileDataImg,
            {
              headers: {
                Authorization: localStorage.getItem('@GSCMX:access_token'),
                'Content-Type': 'multipart/form-data',
              },
            },
          );
          if (response.data.code === 'ERROR') {
            this.modalOpen = true;
            this.modalMessage = response.data.message;
          }
        }
      } catch (e) {
        this.modalOpen = true;
        this.modalMessage = `Houve algum problema ao tentar enviar o documento: <br />${e}`;
      }
    },
    async saveShippingQuote() {
      try {
        const schema = yup.object().shape({
          valorTotalDolar:
            this.quoteData.modal !== 'RODOVIARIA'
              ? yup.string().required('Valor total em Dólar é obrigatório!')
              : null,
          valorTotalEuro:
            this.quoteData.modal !== 'RODOVIARIA'
              ? yup.string().required('Valor total em Euro é obrigatório!')
              : null,
          valorTotalReais:
            this.quoteData.modal !== 'RODOVIARIA'
              ? yup.string().required('Valor total em Reais é obrigatório!')
              : null,
          freetime:
            this.quoteData.modal !== 'RODOVIARIA'
              ? yup.string().nullable().required('Freetime é obrigatório!')
              : null,
          transittime:
            this.quoteData.modal !== 'RODOVIARIA'
              ? yup.string().nullable().required('Transit Time é obrigatório!')
              : null,
          agente: yup.string().required('Forwarder é obrigatório!'),
          localEmbarque: yup.string().nullable().required('Local do Embarque é obrigatório!'),
          portoDestino: yup.string().nullable().required('Porto Destino é obrigatório!'),
          incoterm: yup.string().nullable().required('Incoterm é obrigatório!'),
          modal: yup.string().nullable().required('Modal é obrigatório!'),
          armador: this.quoteData.tipoEmbarque !== 'LCL' && this.quoteData.modal === 'MARITIMA' ? yup.string().nullable().required('Armador é obrigatório!') : yup.string().nullable().notRequired(),
          localDesova: this.quoteData.tipoEmbarque === 'LCL' ? yup.string().nullable().required('Local de Desova é obrigatório!') : yup.string().nullable().notRequired(),
          moeda: this.quoteData.valorTotalOutros !== 0 ? yup.string().nullable().required('Moeda é obrigatória!') : yup.string().nullable().notRequired(),
          containers: yup.array().nullable().of(
            yup.object().shape({
              quantity: yup.number()
                .min(1, 'Quantidade do Container deve ser maior que 0')
                .required('Quantidade do Container é obrigatória!'),
              type: yup.string()
                .required('Tipo do Container é obrigatório!'),
            }),
          ),
          documents: yup.array()
            .min(1, 'Pelo menos um documento deve ser enviado!')
            .required('Pelo menos um documento deve ser enviado!'),
        }).test('cotacaoPreenhida', 'Pelo menos um valor total deve ser preenchido!', (values) => {
          const {
            valorTotalDolar, valorTotalEuro, valorTotalReais, valorTotalOutros,
          } = values;
          return [valorTotalDolar, valorTotalEuro, valorTotalReais, valorTotalOutros].some((value) => parseFloat(value) > 0);
        });

        await schema.validate({ ...this.quoteData, documents: this.documents }, {
          abortEarly: false,
        });

        if (this.documents.length === 0) {
          this.modalOpen = true;
          this.modalMessage = 'Nenhum documento foi enviado!';
        } else {
          this.toggleLoading(true);
          const response = await api.post(
            `/freightQuotation/saveShippingQuote/${this.quoteData.codigo}`,
            {
              ...this.quoteData,
              freetime: parseInt(this.quoteData.freetime),
              transittime: parseInt(this.quoteData.transittime),
            },
          );
          if (response.data.code === 'SUCCESS') {
            await this.uploadFiles();
            this.modalOpen = true;
            this.modalMessage = 'Cotação de Frete enviada com sucesso!';
            this.validationErrors = [];
          } else {
            this.modalOpen = true;
            this.modalMessage = response.data.message;
          }
          this.toggleLoading(false);
        }
      } catch (e) {
        console.log(e);
        if (e.inner) {
          this.validationErrors = e.inner;
          let html = '<div class="text-left pl-4 pr-4 pt-2"><p style="margin-bottom: 10px;">Por favor, preencha os campos obrigatórios abaixo!</p>';
          if (e.inner.length > 0) {
            const uniqueErrors = new Set();
            html += '<ul class="list-disc">';
            e.inner.forEach((error) => {
              if (!uniqueErrors.has(error.message)) {
                uniqueErrors.add(error.message);
                html += `<li style="margin-bottom: 10px;">${error.message}</li>`;
              }
            });
            html += '</ul>';
          }
          html += '</div>';

          Swal.fire({
            title: 'Cotação de frete!',
            html,
            icon: 'error',
            customClass: 'alert-error',
            showConfirmButton: true,
            confirmButtonColor: '#104375',
            confirmButtonText: 'Fechar',
          });
        } else {
          this.modalOpen = true;
          this.modalMessage = e;
        }
        this.toggleLoading(false);
      }
    },
    async deleteContainer(container, index) {
      try {
        Swal.fire({
          title: 'Tem certeza?',
          text: 'Você não poderá reverter isso!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, excluir!',
        }).then((result) => {
          if (result.isConfirmed) {
            if (container?.id) {
              api.delete(`/freight-quotation-containers/quotation/${this.quoteData.codigo}/container/${container.id}`).then((response) => {
                if (response.data.status === 'OK') {
                  this.quoteData.containers.splice(index, 1);
                }
              }).catch((error) => {
                console.error(error);
              });
            } else {
              this.quoteData.containers.splice(index, 1);
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    urgentText() {
      return this.quoteData.urgent ? 'SIM' : 'NÃO';
    },
    imoText() {
      return this.quoteData.imo ? 'SIM' : 'NÃO';
    },
    datesGoodsReadinesDate() {
      if (this.quoteData.datesGoodsReadinesDate) {
        return moment(this.quoteData.datesGoodsReadinesDate).format('DD/MM/YYYY');
      }
      if (this.quoteData.datesEstimatedGoodsReadinesDate) {
        return moment(this.quoteData.datesEstimatedGoodsReadinesDate).format('DD/MM/YYYY');
      }
      return 'N/A';
    },
    customerExpectedReceiptDate(){
      if (this.quoteData.customerExpectedReceiptDate) {
        return moment(this.quoteData.customerExpectedReceiptDate).format('DD/MM/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style scoped>
.bg-quotation-terrestre {
  flex: 0 0 35%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    url('../../assets/img/bg-cotacao-terrestre.jpg') center bottom / cover no-repeat;
}

.bg-quotation {
  flex: 0 0 35%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    url('../../assets/img/bg-cotacao.jpg') center bottom / cover no-repeat;
}

.quotation-form {
  flex: 0 0 65%;
}

.separator {
  width: 100%;
  height: 2px;
  background-color: var(--input-border-color);
}

.quotation-form {
  background-color: var(--white-color);
}

textarea {
  border-radius: var(--medium-border-radius);
  color: var(--black-color);
}

button:disabled {
  background-color: var(--light-bg-color) !important;
  color: var(--light-text-color) !important;
  border: 1px solid var(--light-bg-color) !important;
}

.transbordo {
  background-color: #46a035;
  color: var(--white-color);
  padding: 0.5rem 0.5rem 0.5rem 0.2rem;
  border-radius: var(--medium-border-radius);
  font-size: 1rem;
}

.transbordo.active {
  background-color: #e03434;
}

.transbordo input {
  border-radius: 50%;
  border: 0;
  margin-right: 10px;
}

.transbordo input:checked {
  background: radial-gradient(#000 0%, #000 30%, #fff 30%, #fff 100%);
}

@media screen and (max-width: 1020px) {
  .quote-container {
    flex-direction: column;
  }

  .bg-quotation,
  .bg-quotation-terrestre,
  .quotation-form {
    flex: 0 1 auto;
  }

  .bg-quotation {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
      url('../../assets/img/bg-cotacao.jpg') center bottom / cover no-repeat;
  }

  .bg-quotation-terrestre {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
      url('../../assets/img/bg-cotacao-terrestre.jpg') center bottom / cover no-repeat;
  }
}

.upload-placeholder {
  border: var(--medium-border-width) dashed var(--primary-color);
  border-radius: var(--medium-border-radius);
  padding: 1rem;
}

.upload-placeholder.error {
  border-color: var(--danger-color);
}

.upload-placeholder.active {
  background-color: rgba(16, 67, 117, 0.7);
}
.text-right {
  text-align: right !important;
}

.styled-select {
  z-index: unset !important;
}

.quotation {
  min-width: 230px;
}

.quotation-currency {
  min-width: 135px;
}

.quotation-tax {
  min-width: 135px;
}

</style>

<style>
.select-new {
  /* border: var(--input-border) !important;
  border-radius: var(--medium-border-radius) !important; */
  width: 100%;
  height: 2.8125rem !important;
  border: var(--input-border) !important;
  border-radius: var(--medium-border-radius) !important;
  padding: 1rem;
  transition: var(--input-transition);
  background-color: var(--white-color) !important;
  font-size: 1rem;
  color: #000000;
  font-weight: bold;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
}
.select-new:hover {
  border: var(--input-border-hovered) !important;
}
.select-new .selected-option {
  margin-top: 9px;
  text-overflow: unset !important;
  width: 100% !important;
}

.select-new .options {
  z-index: 9999 !important;
}

.alert-error {
  width: 550px !important;
}

.list-disc {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  padding-inline-start: 40px;
  unicode-bidi: isolate;
}
</style>
